import { BASE_HOST } from '../env';

const keyName = 'mozer-player-token';
const cookieTokenName = 'mozermovie';

export const saveAuthToken = (token) => {
  localStorage.setItem(keyName, token);
};

export const getAuthToken = () => {
  return localStorage.getItem(keyName);
};

export const removeAuthToken = () => {
  localStorage.removeItem(keyName);
};

export const setCookieToken = (value) => {
  let domain;
  switch (BASE_HOST) {
    case undefined:
    case 'localhost':
      domain = 'localhost';
      break;
    default:
      domain = `.${BASE_HOST}`;
  }
  document.cookie = `${cookieTokenName}=${value}; domain=${domain}; path=/`;
};

export const getCookieToken = () => {
  const cookies = document.cookie;
  const value = `; ${cookies}`;
  const parts = value.split(`; ${cookieTokenName}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

export const deleteCookieToken = () => {
  let domain;
  if (process.env.BASE_HOST === 'localhost') {
    domain = process.env.BASE_HOST;
  } else {
    domain = `.${process.env.BASE_HOST}`;
  }
  document.cookie = `${cookieTokenName}=''; domain=${domain}; path=/; max-age=0`;
};
